// The six steps of a D2C request, for the progress indicator. Presentation
// only: the stage itself comes from the OMS (ops/activity, ops/orders/{id}).
export const STEPS = ["Offered", "Accepted", "Scanned", "PDI", "Out for delivery", "Delivered"];

const STEP_OF_STAGE = {
  WAITING_FOR_DEALER: 0,
  ACCEPTED: 1,
  FRAME_RESERVED: 2,
  PDI_DONE: 3,
  OUT_FOR_DELIVERY: 4,
  DELIVERED: 5,
};
const STOPPED = new Set(["RETURNED_TO_CENTRAL", "CANCELLED"]);

// {index, stopped}: index is the step reached (0-5), -1 when unknown.
export const stageStep = (stage) => ({
  index: stage in STEP_OF_STAGE ? STEP_OF_STAGE[stage] : -1,
  stopped: STOPPED.has(stage),
});

const OPEN_STAGES = new Set(["WAITING_FOR_DEALER", "ACCEPTED", "FRAME_RESERVED", "PDI_DONE", "OUT_FOR_DELIVERY"]);

const sameIstDay = (iso, now, timezone) =>
  Boolean(iso) &&
  new Date(iso).toLocaleDateString("en-CA", { timeZone: timezone }) ===
    new Date(now).toLocaleDateString("en-CA", { timeZone: timezone });

// Counts for the Activity KPI strip, from the rows already loaded (no extra
// API call). "In progress" uses the server total when the list is open-only.
// "Delivered today" needs the All recent list; it is null otherwise.
export const activityKpis = (items, { openOnly, total, now = new Date(), timezone = "Asia/Kolkata" }) => {
  const rows = items || [];
  const count = (test) => rows.filter(test).length;
  return {
    inProgress: openOnly ? Number(total) || 0 : count((row) => OPEN_STAGES.has(row.stage)),
    waiting: count((row) => row.stage === "WAITING_FOR_DEALER"),
    outForDelivery: count((row) => row.stage === "OUT_FOR_DELIVERY"),
    deliveredToday: openOnly
      ? null
      : count((row) => row.stage === "DELIVERED" && sameIstDay(row.last_activity_at, now, timezone)),
  };
};

// The OMS's plain-English stage labels (dealerapp/d2c/ops/metrics.STAGE_LABELS).
// ops/activity sends them; ops/orders/{id} sends only the stage, so the order
// panel looks the label up here.
export const STAGE_LABELS = {
  WAITING_FOR_DEALER: "Waiting for a dealer to accept",
  ACCEPTED: "Accepted, frame not scanned yet",
  FRAME_RESERVED: "Frame scanned, PDI pending",
  PDI_DONE: "PDI done, not dispatched yet",
  OUT_FOR_DELIVERY: "Out for delivery, OTP sent",
  DELIVERED: "Delivered",
  RETURNED_TO_CENTRAL: "Returned to central",
  CANCELLED: "Cancelled",
};
